// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"1b1fe7b4de394145","8238":"cbdca2b7079d2f7b"}[chunkId] + ".css";
};